import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { getMe } from './features/auth/api.js';
import { ApiError, onUnauthorized } from './lib/api-client.js';
import { router } from './router.js';
import { useAuthStore } from './stores/auth-store.js';

export function App() {
  const setUser = useAuthStore((s) => s.setUser);
  const setBootstrapping = useAuthStore((s) => s.setBootstrapping);
  const clear = useAuthStore((s) => s.clear);
  const bootstrapping = useAuthStore((s) => s.bootstrapping);

  useEffect(() => {
    // Boot: tenta restaurar sessão via cookie HTTP-only.
    (async (): Promise<void> => {
      try {
        const me = await getMe();
        setUser(me);
      } catch (err) {
        if (err instanceof ApiError && err.problem.status === 401) {
          clear();
        }
      } finally {
        setBootstrapping(false);
      }
    })();

    // Listener global: qualquer 401 (após boot) leva pra /login.
    return onUnauthorized(() => {
      clear();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    });
  }, [setUser, setBootstrapping, clear]);

  if (bootstrapping) {
    return (
      <div className="flex h-screen items-center justify-center text-[13px] text-n-500">
        Carregando...
      </div>
    );
  }

  return (
    <>
      <RouterProvider router={router} />
      <Toaster richColors position="top-center" closeButton duration={6000} />
    </>
  );
}
